import React, { useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { BiEnvelope } from "react-icons/bi";
import { BsBuilding, BsCalendar, BsPhone } from "react-icons/bs";
import { ImAttachment } from "react-icons/im";
import { FormattedMessage } from "react-intl";

const Work = () => {
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  return (
    <div className="contact-tab">
      <div className="text1">
        <h1 className="mid-title">
          <FormattedMessage
            id="Talk"
            defaultMessage="Let's talk"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="Tell"
            defaultMessage="Tell us about your project"
          />
        </p>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col">
              <label htmlFor="fullName">
                <FormattedMessage
                  id="Fullname"
                  defaultMessage="Full name"
                />
              </label>
              <div className="input">
                <AiOutlineUser />
                <input
                  type="text"
                  id="EnterFullname"
                  placeholder="Enter full name"
                />
              </div>
            </div>
            <div className="col">
              <label htmlFor="companyName">
                <FormattedMessage
                  id="Comapnyname"
                  defaultMessage="Company name"
                />
              </label>
              <div className="input">
                <BsBuilding />
                <input
                  type="text"
                  id="EntercompanyName"
                  placeholder="Enter company or organization name"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <label htmlFor="email">
                <FormattedMessage
                  id="contact-tab1-label3"
                  defaultMessage="Email"
                />
              </label>
              <div className="input">
                <BiEnvelope />
                <input type="email" id="EnterWorkEmail" placeholder="Enter work email" />
              </div>
            </div>
            <div className="col">
              <label htmlFor="phoneNumber">
                <FormattedMessage
                  id="PhoneNumber"
                  defaultMessage="Phone number"
                />
              </label>
              <div className="input">
                <BsPhone />
                <input
                  type="number"
                  id="EnterPhoneNumber"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="budget">
                <FormattedMessage
                  id="Budget"
                  defaultMessage="What's your planned budget?"
                />
              </label>
              <div className="input">
                <BiEnvelope className="blank" />
                <select name="budget" id="budget">
                  <option value="" defaultChecked >
                    <FormattedMessage id="Please" defaultMessage="Please Select"/>
                  </option>
                  <option value="1000+">1000+</option>
                </select>
              </div>
            </div>
            <div className="col">
              <label htmlFor="date">
                <FormattedMessage
                  id="PhoneNumber"
                  defaultMessage="Phone number"
                />
              </label>
              <div className="input">
                <BiEnvelope className="blank" />

                <input
                  type="number"
                  id="Date"
                  placeholder="Select estimated date to be completed"
                />
                <BsCalendar />
              </div>
            </div>
          </div>

          <div className="col">
            <label htmlFor="textArea">
              <FormattedMessage
                id="contact-tab1-label7"
                defaultMessage="Message"
              />
            </label>
            <textarea
              name="textArea"
              id="textArea"
              cols="30"
              rows="10"
            ></textarea>
          </div>

          <div className="input">
            <ImAttachment />
            <input type="file" />
          </div>

          <button className="styledButton">
            <p className="def-text">
              <FormattedMessage id="Submit" defaultMessage="Submit" />
            </p>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Work;
